import { render, staticRenderFns } from "./Flippingbook.vue?vue&type=template&id=307f52e6"
import script from "./Flippingbook.vue?vue&type=script&lang=js"
export * from "./Flippingbook.vue?vue&type=script&lang=js"
import style0 from "./Flippingbook.vue?vue&type=style&index=0&id=307f52e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports